export const getRaOptimal = state => state.raOptimal;
